import { ReactNode } from 'react';
import { Placement } from '@floating-ui/react';
import { ITooltipOption } from './globalTooltips';
import StyledKubitTooltip from './StyledKubitTooltip';

interface IProps extends ITooltipOption {
  children: ReactNode | string;
  placement?: Placement;
  disabled?: boolean;
  actionLinkAsSpan?: boolean;
  noOpenDelay?: boolean;
}

const KubitTooltip = ({ children, disabled, content, ...props }: IProps) => {
  if (!content || disabled) {
    return <>{children}</>;
  }

  return (
    <StyledKubitTooltip {...props} content={content}>
      {typeof children === 'string' ? <div>{children}</div> : children}
    </StyledKubitTooltip>
  );
};

export default KubitTooltip;
